import type { SxProps, Theme } from '@mui/material/styles';

export const messageRowSx: SxProps<Theme> = {
  display: 'flex',
  width: '100%',
  gap: 1.5,
  justifyContent: 'flex-start',
  alignItems: 'center',
  overflowWrap: 'break-word',
  overflow: 'auto',
};
